// For full API documentation, including code examples, visit http://wix.to/94BuAAs
 import wixWindow from 'wix-window';

$w.onReady(function () {
$w("#html2").scrolling = "no";
$w("#html1").scrolling = "no";


// if (wixWindow.formFactor === "Mobile") {
// 	$w('#group1').hide()

// } 


	//TODO: write your page related code here...
// $w("#html1").scrolling = "no";

// $w("#html1").src.formFactor =  "Tablet"


});

export function columnStrip2_viewportEnter(event) {
	// $w('#columnStrip2').scrollTo()
	//Add your code for this event here: 
}

export function columnStrip4_viewportEnter(event) {
	// $w('#columnStrip4').scrollTo()
	//Add your code for this event here: 
}

export function button3_click(event) {
	$w("#html1").postMessage({src: "https://www.lemaanchem.com/"});	
	$w("#html2").postMessage({src: "https://www.lemaanchem.com/"});	

	//Add your code for this event here: 
}

export function button4_click(event) {
	$w("#html1").postMessage({src: "https://www.powergym.co.il/"});	
	$w("#html2").postMessage({src: "https://www.powergym.co.il/"});	

	//Add your code for this event here: 
}

export function button5_click(event) {
	 
	 	$w("#html1").postMessage({src: "https://www.elieyshay.com/"});	
	 	$w("#html2").postMessage({src: "https://www.elieyshay.com/"});	

	//Add your code for this event here: 
}

export function button6_click(event) {
		 	$w("#html1").postMessage({src: "https://www.sodot-hakabala.co.il/"});	
		 	$w("#html2").postMessage({src: "https://www.sodot-hakabala.co.il/"});	

}

export function button7_click(event) {
		 	$w("#html1").postMessage({src: "https://www.nofhayarden.com/"});	
		 	$w("#html2").postMessage({src: "https://www.nofhayarden.com/"});	

	//Add your code for this event here: 
}

export function button8_click(event) {
$w("#html1").postMessage({src: "https://www.av-digital.co.il/"});	
		 	$w("#html2").postMessage({src: "https://www.av-digital.co.il/"});	}

export function button9_click(event) {
	$w("#html1").postMessage({src: "https://www.tovirot.com/ace"});	
	$w("#html2").postMessage({src: "https://www.tovirot.com/ace"});

}

export function button10_click(event) {
	$w("#html1").postMessage({src: "https://www.hilula.org/"});	
	$w("#html2").postMessage({src: "https://www.hilula.org/"});

	//Add your code for this event here: 
}

export function button11_click(event) {
	$w("#html1").postMessage({src: "https://www.tovirot.com"});	
	$w("#html2").postMessage({src: "https://www.tovirot.com"});
	//Add your code for this event here: 
}